export default __webpack_public_path__ + "static/media/delete.9e3b6da7.svg";